// extracted by mini-css-extract-plugin
module.exports = {"HalfHalf":"index-module__HalfHalf___1TPWH","evolved":"index-module__evolved___3CS9P"};